import {ISchool} from '../interface/School'
export const schoolsFormDataModal: ISchool = {
    schoolID: 0,
    schNum: "",
    schNam: "",
    principal: "",
    addr1: "",
    addr2: "",
    districtId: 0,
    distNum: "",
    distNam: "",
    siteNum: "",
    siteNam: "",
    dismisal: "",
    trans: "",
    email: "",
    hidden: false,
    notes: ""
}